import { Stack, Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { RadioGroup, SelectInput, TextInput } from '@/components/inputs'
import {
  MARITAL_STATUS_OPTIONS,
  PHONE_TYPE_OPTIONS,
  SEX_OPTIONS,
  YES_NO_OPTIONS,
} from './constants'
import { RcpAddressFields } from './rcp-address-fields'
import { RcpQuoteFormData } from './schema'

export function StepCadastro() {
  const { control, watch } = useFormContext<RcpQuoteFormData>()
  const hasSocialName = watch('has_social_name')
  const useResidentialAsBilling = watch('use_residential_as_billing')

  return (
    <Stack spacing={3}>
      <Typography variant="h6">Etapa 1 — Cadastro</Typography>

      <TextInput
        control={control}
        name="full_name"
        label="Nome completo do proponente"
      />

      <RadioGroup
        control={control}
        name="has_social_name"
        label="Possui nome social?"
        options={YES_NO_OPTIONS}
        isBooleanChoice
        row
      />

      {hasSocialName && (
        <TextInput control={control} name="social_name" label="Nome social" />
      )}

      <RadioGroup
        control={control}
        name="sex"
        label="Sexo"
        options={[...SEX_OPTIONS]}
        row
      />

      <TextInput
        control={control}
        name="tax_id"
        label="CPF"
        mask="000.000.000-00"
      />

      <RadioGroup
        control={control}
        name="phone_type"
        label="Tipo de telefone"
        options={[...PHONE_TYPE_OPTIONS]}
        row
      />

      <TextInput
        control={control}
        name="phone"
        label="Telefone"
        type="tel"
        mask="(00) 00000-0000"
      />

      <TextInput
        control={control}
        name="email"
        label="E-mail (para envio da apólice)"
        type="email"
      />

      <Typography variant="subtitle1">Endereço residencial</Typography>
      <RcpAddressFields prefix="residential_address" />

      <RadioGroup
        control={control}
        name="use_residential_as_billing"
        label="Caso você siga com o Seguro, deseja utilizar o endereço residencial como endereço de cobrança? Não se preocupe, nada será cobrado neste momento."
        options={YES_NO_OPTIONS}
        isBooleanChoice
      />

      {!useResidentialAsBilling && (
        <>
          <Typography variant="subtitle1">Endereço de cobrança</Typography>
          <RcpAddressFields prefix="billing_address" />
        </>
      )}

      <SelectInput
        control={control}
        name="marital_status"
        label="Estado civil"
        options={[...MARITAL_STATUS_OPTIONS]}
      />

      <RadioGroup
        control={control}
        name="is_politically_exposed"
        label="É pessoa politicamente exposta?"
        options={YES_NO_OPTIONS}
        isBooleanChoice
        row
      />

      <RadioGroup
        control={control}
        name="lives_in_brazil"
        label="Reside no Brasil?"
        options={YES_NO_OPTIONS}
        isBooleanChoice
        row
      />
    </Stack>
  )
}
